export const SET_PLACEMENT_FILE = 'SET_PLACEMENT_FILE'
export const SELECT_PLACEMENT_CARD = 'SELECT_PLACEMENT_CARD'
export const PLACEMENT_TITLE = 'PLACEMENT_TITLE'
export const PLACEMENT_HYPERLINK = 'PLACEMENT_HYPERLINK'
export const PLACEMENT_DESCRIPTION = 'PLACEMENT_DESCRIPTION'
export const RESET_EDIT_PLACEMENTS = 'RESET_EDIT_PLACEMENTS'
export const RESET_EDIT_CAMPAIGN = 'RESET_EDIT_CAMPAIGN'
export const SET_EDITED_CAMPAIGN = 'SET_EDITED_CAMPAIGN'
export const SET_PLACEMENT_EDITED = 'SET_PLACEMENT_EDITED'

export const setEditedCampaign = payload => dispatch =>
  dispatch({
    type: SET_EDITED_CAMPAIGN,
    payload: payload
  })
export const setPlacementFile = payload => dispatch => {
  dispatch({
    type: SET_PLACEMENT_FILE,
    payload: payload
  })

  if (payload?.file?.fileName) {
    dispatch(setPlacementEdited(true))
  }
}

export const selectPlacementCard = payload => dispatch =>
  dispatch({
    type: SELECT_PLACEMENT_CARD,
    payload: payload
  })
export const setPlacementTitle = payload => dispatch =>
  dispatch({
    type: PLACEMENT_TITLE,
    payload: payload
  })
export const setPlacementHyperlink = payload => dispatch =>
  dispatch({
    type: PLACEMENT_HYPERLINK,
    payload: payload
  })
export const setPlacementDescription = payload => dispatch =>
  dispatch({
    type: PLACEMENT_DESCRIPTION,
    payload: payload
  })
export const resetEditPlacements = () => dispatch =>
  dispatch({
    type: RESET_EDIT_PLACEMENTS
  })
export const resetEditCampaign = () => dispatch =>
  dispatch({
    type: RESET_EDIT_CAMPAIGN
  })
export const setPlacementEdited = payload => dispatch => {
  dispatch({
    type: SET_PLACEMENT_EDITED,
    payload: payload
  })
}
